import { memo, useMemo } from 'react'
import type { MemberSummary } from '../../lib/infoserviceApi.js'
import { QUOTA_SLOTS_MAX, memberQuotaText, quotaSlots, quotaTone } from '../../lib/memberQuota.js'

/**
 * Jauge du droit annuel : une case par semaine jusqu'à 12 ; au-delà
 * (entreprise, 52 semaines) une barre, les cases ne se lisant plus. Le compte
 * (« 8 / 12 ») est toujours écrit à côté.
 */
export const QuotaGauge = memo(function QuotaGauge({ member, wide = false }: { member: MemberSummary; wide?: boolean }) {
  const slots = useMemo(() => quotaSlots(member), [member])
  const tone = quotaTone(member)
  const text = memberQuotaText(member)
  const bar = member.quota > QUOTA_SLOTS_MAX
  return (
    <span className={`quota-gauge is-${tone}${wide ? ' is-wide' : ''}`} role="img" aria-label={text} title={text}>
      {bar ? (
        <span className="quota-gauge__bar" aria-hidden="true">
          <span className="quota-gauge__bar-passed" style={{ width: `${Math.min(100, (member.weeksPassed / member.quota) * 100)}%` }} />
          <span className="quota-gauge__bar-planned" style={{ width: `${Math.max(0, Math.min(100, (member.weeksUsed / member.quota) * 100) - Math.min(100, (member.weeksPassed / member.quota) * 100))}%` }} />
        </span>
      ) : (
        <span className="quota-gauge__slots" aria-hidden="true">
          {slots.map((slot, index) => (
            <span key={index} className={`quota-gauge__slot is-${slot.kind}${slot.over ? ' is-over' : ''}`} />
          ))}
        </span>
      )}
      {!wide && <span className="quota-gauge__count">{member.weeksUsed} / {member.quota}</span>}
    </span>
  )
})
